import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Provider as RollbarProvider, ErrorBoundary } from '@rollbar/react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from '@/App';
import store from '@/store';
import { ENV } from '@/config';
import '@/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const rollbarConfig = {
  accessToken: '44029c886064421e9b2c7d6d63ffaec3',
  environment: ENV,
  enabled: !isLocalhost,
};

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <RollbarProvider config={rollbarConfig}>
    <ErrorBoundary>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </Provider>
    </ErrorBoundary>
  </RollbarProvider>
);
